/**
 * Local: REACT_APP_API_URL=http://localhost:3000
 * Vercel/iPhone: REACT_APP_API_URL=/api  (proxy → devhood-api.com)
 */
export const normalizeBaseURL = (value) => {
  const raw = String(value || '').trim().replace(/\/+$/, '');
  if (!raw) return '';
  if (raw.startsWith('/')) return raw;
  if (/^https?:\/\//i.test(raw)) return raw;
  const isLocalHostLike = /^(localhost|127\.0\.0\.1|0\.0\.0\.0)(:\d+)?$/i.test(raw);
  return `${isLocalHostLike ? 'http' : 'https'}://${raw}`;
};

const resolveConfiguredApiUrl = () => {
  // Producción (Vercel, iPhone, acceso directo): siempre mismo origen /api → proxy.
  // Ignora REACT_APP_API_URL=https://devhood-api.com en Vercel (rompe iOS).
  if (typeof window !== 'undefined' && window.location?.hostname) {
    const { hostname } = window.location;
    if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
      return '/api';
    }
  }

  const fromEnv = String(process.env.REACT_APP_API_URL || '').trim();
  if (fromEnv) return fromEnv;

  return '';
};

const configured = resolveConfiguredApiUrl();

if (!configured) {
  throw new Error(
    'Falta REACT_APP_API_URL. Copia .env.example a .env y define la URL del backend.',
  );
}

export const API_BASE_URL = normalizeBaseURL(configured);
